<template>
	<div class="spofaq-searchapp__result-posts" role="region">
		<template v-for="post in posts">
			<Post
				:key="post.id"
				:post="post"
				:open="isOpen"
				@toggled="toggleDetails"
			>
			</Post>
		</template>
	</div>
</template>

<script>
import Post from "./Post";
export default {
	name: "Posts",
	data() {
		return { isOpen: -1 };
	},
	components: {
		Post,
	},
	props: ["posts"],
	methods: {
		toggleDetails(id) {
			if (this.isOpen === id) {
				this.isOpen = -1;
				return;
			}
			this.isOpen = id;
		},
	},
};
</script>
